import {createContext, useContext} from "react";

export interface LogEntry {
  type: "log" | "info" | "warn" | "error";
  message: string;
  timestamp: Date;
}

export interface LoggingContextType {
  logs: LogEntry[];
  clearLogs: () => void;
  isVisible: boolean;
  toggleVisibility: () => void;
  exportLogs: () => void;
  enabled: boolean;
}

export const LoggingContext = createContext<LoggingContextType | undefined>(
  undefined,
);

export const useLogging = (): LoggingContextType => {
  const context = useContext(LoggingContext);
  if (!context) {
    throw new Error("useLogging must be used within a LoggingProvider");
  }
  return context;
};
